import React from 'react';
import CookbookFilteredMealListContainer from './CookbookFilteredMealListContainer';
import {
  useTimestamp,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';

export const CookbookFilteredMealListPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();

  const location = useLocation();
  const meals = location.state.meals;

  return (
    <AddFavoriteCookbookMealConnectorApollo>
      {({ addCookbookMealToFavorite }) => (
        <RemoveFavoriteCookbookMealConnectorApollo>
          {({ removeCookbookMealFromFavorites }) => (
            <CookbookFilteredMealListContainer
              meals={meals}
              addToFavorites={addCookbookMealToFavorite}
              removeFromFavorites={removeCookbookMealFromFavorites}
              key={timestamp1}
            />
          )}
        </RemoveFavoriteCookbookMealConnectorApollo>
      )}
    </AddFavoriteCookbookMealConnectorApollo>
  );
};

export default CookbookFilteredMealListPage;
